import type { Product } from '@/types'

export type ProductDetailLocationState = {
  product?: Product
}

/** Product passed from a card/grid navigation (same session, matching id). */
export function readProductFromLocationState(
  state: unknown,
  productId: string
): Product | null {
  if (!state || typeof state !== 'object') return null
  const product = (state as ProductDetailLocationState).product
  if (!product || product.id !== productId) return null
  if (!product.name || typeof product.name !== 'string') return null
  return product
}

export function productDetailLinkState(product: Product): ProductDetailLocationState {
  return { product }
}
